"use strict";

import TextInput from "@/legacy/form/TextInput.jsx";

export const MAX_STEP_TITLE_LENGTH = 100;

/*
 * Optional user-defined label for a step. When set it replaces the description generated
 * from the step template, both in this editor and in alerts and root cause analysis.
 *
 * API checks are excluded, so the input is not rendered for them.
 */
export default function StepTitleInput({step, monitoringServiceType, onChange}) {
  if (monitoringServiceType === "API" || !onChange) {
    return null;
  }

  return (
    <TextInput
      fieldName="step_title"
      labelText="Step Title"
      titleText="Optional. Shown instead of the step description in the step list, alerts and root cause analysis."
      placeholder="e.g. Submit login form"
      maxLength={MAX_STEP_TITLE_LENGTH}
      value={step.title || ""}
      onChange={function (e) {
        onChange(e.target.value);
      }}
    />
  );
}
